export default {
  LARGE: 992
};